module.exports = __webpack_public_path__ + "static/media/WILLPOWER_LOW.4f590987.md";